export default __webpack_public_path__ + "images/f97061863aec93a87a1f0ee1bec64ffe-infoСircle.svg";